import "./CatAnimation.css";
import catTyping from "../../../assets/cat-typing.webp";
const CatAnimation = () => {
  return (
    <div className="cat-typing">
      <img src={catTyping} alt="" />
    </div>
  );
};

export default CatAnimation;
